module.exports = "pegasus/assets/graycircle-youtube.gif";